
const contactUs = {
  'contactUs.title': 'Sponsora mı İhtiyacınız Var? Yardıma mı İhtiyacınız Var?',
  'contactUs.subtitle': 'Yardım etmek için buradayız',
  'contactUs.whatsapp.title': 'WhatsApp ile bize ulaşın',
  'contactUs.email.title': 'E-posta ile bize ulaşın',
  'contactUs.whatsapp.urgent': 'Acil sorularınız için doğrudan WhatsApp\'tan bize ulaşın. Ekibimiz en kısa sürede size yanıt verecektir.',
  'contactUs.languages.english': 'English',
  'contactUs.languages.italian': 'Italiano',
  'contactUs.languages.spanish': 'Español',
  'contactUs.languages.german': 'Deutsch',
  'contactUs.languages.croatian': 'Hrvatski',
  'contactUs.languages.turkish': 'Türkçe',
  'contactUs.languages.french': 'Français',
  'contactUs.languages.arabic': 'العربية',
};

export default contactUs;
